export default __webpack_public_path__ + "static/media/GrandOuest.c08d1249.jpg";